function setCookie(name, value, hours) {
  const d = new Date();
  d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getCookie(name) {
  const cookieName = name + "=";
  const cookieArray = decodeURIComponent(document.cookie).split(";");
  for (let c of cookieArray) {
    c = c.trim();
    if (c.indexOf(cookieName) === 0) return c.substring(cookieName.length);
  }
  return "";
}

function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function updateStockCounts() {
  const els = document.querySelectorAll(".stockcount[data-product-id]");

  els.forEach((el) => {
    const productId = el.dataset.productId;
    const cookieName = "stockCount_" + productId;

    let stockCount = getCookie(cookieName);
    if (stockCount === "") {
      stockCount = String(getRandomNumber(3, 8));
      setCookie(cookieName, stockCount, 1); // 1 hour
    }

    el.textContent = stockCount;
  });
}

document.addEventListener("DOMContentLoaded", updateStockCounts);
